module.exports = {"530630001":"云富街道","530630101":"向家坝镇","530630102":"太平镇","530630103":"两碗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530630.json
// module id = 2399
// module chunks = 0